import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { invoiceKeys } from '@/lib/queryKeys';
import { invoiceEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api/client';
import { normalizeInvoice } from './useInvoice';
import type { Invoice } from '@/types/invoice';

export function useWriteOffInvoice() {
  const queryClient = useQueryClient();

  return useApiMutation<Invoice, string>({
    mutationFn: async (id) =>
      normalizeInvoice(
        await apiPost<Record<string, unknown>, Record<string, never>>(
          operationsClient,
          invoiceEndpoints.writeOff(id),
          {},
        ),
      ),
    onSuccess: (data) => {
      queryClient.setQueryData<Invoice>(invoiceKeys.detail(data.id), (current) =>
        current
          ? {
              ...current,
              ...data,
              contact: data.contact ?? current.contact,
            }
          : data,
      );
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.detail(data.id) });
      void queryClient.invalidateQueries({ queryKey: invoiceKeys.lists() });
      toast.success('Invoice written off');
    },
  });
}
